var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.18,
    height: 36.824,
    viewBox: "0 0 35.18 36.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2",
    "data-name": "Group 2",
    transform: "translate(1 1.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Oval",
    cx: 3.288,
    cy: 3.288,
    r: 3.288,
    className: "prefix__cls-1",
    transform: "translate(19.729 27.949)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Oval-2",
    cx: 3.288,
    cy: 3.288,
    r: 3.288,
    className: "prefix__cls-1",
    "data-name": "Oval",
    transform: "translate(4.932 27.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M32.881 0l-9.133 23.017H5.48L0 7.672h29.838",
    className: "prefix__cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.556cfe4dd519b8d05243e2c8f80b14d7.svg";
export { ForwardRef as ReactComponent };